module.exports = __webpack_public_path__ + "img/vip1.02a34293.png";